import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import type { Evento } from '@/lib/supabase/tipos-bd'

/**
 * Lo que pasó DENTRO de una etapa del recorrido.
 *
 * No hay una tabla de "etapas": el relato ya está en la bitácora. Una etapa es
 * una franja de tiempo (migración 0105 la expone), así que sus hechos son los
 * eventos de esa franja. Se buscan por NÚMERO de documento —la orden de
 * servicio, su cotización y su orden de trabajo— porque la vista del archivo
 * trae los números, no los ids, y así se ven los tres módulos juntos: lo que
 * hizo comercial, lo que hizo programación y lo que hizo el técnico.
 *
 * Solo se consulta cuando la etapa está desplegada.
 */
export function useEventosDeEtapa(
  numeros: (string | null | undefined)[],
  entrada: string | null,
  salida: string | null,
  activo: boolean,
) {
  const docs = numeros.filter((n): n is string => Boolean(n))

  const consulta = useQuery({
    queryKey: ['eventos-etapa', docs.join('|'), entrada, salida],
    enabled: activo && docs.length > 0 && Boolean(entrada),
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<Evento[]> => {
      let peticion = supabase
        .from('eventos')
        .select('*')
        .in('documento_numero', docs)
        .gte('ocurrido_en', entrada!)
        .order('ocurrido_en', { ascending: true })

      // La etapa en curso no tiene salida: se muestra hasta hoy.
      if (salida) peticion = peticion.lt('ocurrido_en', salida)

      const { data, error } = await peticion
      if (error) return []
      return (data ?? []) as Evento[]
    },
  })

  return { eventos: consulta.data ?? [], cargando: consulta.isLoading }
}
